import { render, staticRenderFns } from "./livestockSummaryYoungCow.vue?vue&type=template&id=5b3eac34&scoped=true&"
import script from "./livestockSummaryYoungCow.vue?vue&type=script&lang=js&"
export * from "./livestockSummaryYoungCow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3eac34",
  null
  
)

export default component.exports